import React from 'react';
import './EarthlinkProvider.css';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import provider1 from "../../Includes/Images/elnk-logo-2.png";
import provider2 from "../../Includes/Images/Group-1171274979-2.png";
import { Link } from 'react-router-dom';
const EarthlinkProvider = () => {
  return (
    <>
    <Header/>
    <div className="el-earthlink-container">
      {/* Header Section */}
      <header className="el-earthlink-header">
        <div className="el-logo-container">
          <img src={provider1} alt="EarthLink Logo" className="el-earthlink-logo" />
        </div>
      </header>

      {/* Top Section - 100GB Plan */}
      <section className="el-top-section">
        <div className="el-plan-content">
          <div className="el-plan-badge">100GB Essentials Plan</div>
          <h1 className="el-plan-title">
            <span className="el-reliable">RELIABLE</span>
            <span className="el-five-g">5G</span>
          </h1>
          <h2 className="el-home-internet-title">HOME INTERNET</h2>
          <p className="el-pain-point-text">
            Tired of bait-and-switch offers from providers? Slow speeds, 
            unexpected fees, unreliable service, and those sneaky price jumps 
            after a year? We've been there.
          </p>
          <a href="tel:+18442172287" className="el-call-button">
            <span className="el-phone-icon">📞</span> +1-888-348-6689
          </a>
        </div>
        <div className="el-hero-image-container">
          {/* <img src={provider1} alt="Customer using laptop" className="el-hero-image" /> */}
        </div>
      </section>

      {/* Middle Section - Experience Unmatched */}
      <section className="el-middle-section">
        <div className="el-router-section">
          <div className="el-person-router-container">
            <img src={provider2} alt="Person with router" className="el-person-router-image" />
          </div>
        </div>
        <div className="el-unmatched-content">
          <h3 className="el-section-tag">HOME INTERNET</h3>
          <h2 className="el-unmatched-title">
            Experience Unmatched <span className="el-orange-text">Internet</span> Services
          </h2>
          <p className="el-unmatched-text">
            At EarthLink, we're more than just your provider – we're your internet partner 
            you trust. Even better, we're more widely available than any other ISP in the 
            continental U.S.
          </p>
          <p className="el-unmatched-text">
            Bypass the frustrations and gimmicks from the usual suspects like Xfinity, 
            Cox, Spectrum, Bright House, Optimum, and the rest. No more chasing flashy 
            offers and being left on hold forever.
          </p>
          <p className="el-unmatched-text">
            When you're shopping for new internet, it can be a little overwhelming 
            finding the right fit for you. EarthLink has several high-speed internet plans 
            so you can choose the best option
          </p>
          <a href="tel:+18442172287" className="el-call-button">
            <span className="el-phone-icon">📞</span> +1-888-348-6689
          </a>
        </div>
      </section>

      {/* Features Section */}
      <section className="el-features-section">
        <h3 className="el-section-tag el-centered">HOME INTERNET</h3>
        <h2 className="el-features-title">
          Experience Unmatched<span className="el-orange-text">Internet</span> Services
        </h2>
        
        <div className="el-features-grid">
          <div className="el-feature-card">
            <div className="el-feature-icon el-globe-icon">🌐</div>
            <h3 className="el-feature-title">Largest Network</h3>
            <p className="el-feature-description">With speeds up to 5 Gigs, we have an option for everyone</p>
          </div>
          
          <div className="el-feature-card">
            <div className="el-feature-icon el-database-icon">💾</div>
            <h3 className="el-feature-title">No Data Caps</h3>
            <p className="el-feature-description">Unlimited data and no speed throttling</p>
          </div>
          
          <div className="el-feature-card">
            <div className="el-feature-icon el-money-icon">💵</div>
            <h3 className="el-feature-title">Price Guarantee</h3>
            <p className="el-feature-description">Lock in our best rates and rest easy</p>
          </div>
          
          <div className="el-feature-card">
            <div className="el-feature-icon el-lock-icon">🔒</div>
            <h3 className="el-feature-title">Stay Secure</h3>
            <p className="el-feature-description">Lock in our best rates and rest easy</p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="el-pricing-section">
        <h3 className="el-section-tag el-centered">HOME INTERNET</h3>
        <h2 className="el-pricing-title">Flexible Pricing Plan For Your Home</h2>
        
        <div className="el-pricing-cards-container">
          <div className="el-pricing-card">
            <div className="el-pricing-card-header el-blue">
              <h4 className="el-pricing-card-badge">BEST VALUE REALLY FAST</h4>
            </div>
            <div className="el-pricing-card-content">
              <h3 className="el-speed-title">Up to 100 Mbps</h3>
              <p className="el-billing-cycle">Billed annually</p>
              
              <ul className="el-features-list">
                <li className="el-feature-item">One $100 gift card***</li>
                <li className="el-feature-item">Ideal for small households</li>
                <li className="el-feature-item">Great for streaming, casual gaming</li>
                <li className="el-feature-item">Private secure internet connection</li>
              </ul>
              
              <a href="tel:+18442172287" className="el-call-button el-blue-btn">
                <span className="el-phone-icon">📞</span> +1-888-348-6689
              </a>
            </div>
          </div>
          
          <div className="el-pricing-card el-popular">
            <div className="el-pricing-card-header el-orange">
              <h4 className="el-pricing-card-badge">MOST POPULAR SUPER-FAST</h4>
            </div>
            <div className="el-pricing-card-content">
              <h3 className="el-speed-title">Up to 300 Mbps</h3>
              <p className="el-billing-cycle">Billed annually</p>
              
              <ul className="el-features-list">
                <li className="el-feature-item">One $200 gift card***</li>
                <li className="el-feature-item">Great for super-connected households</li>
                <li className="el-feature-item">Multiple users, multiple devices</li>
                <li className="el-feature-item">No data caps, no throttling</li>
                <li className="el-feature-item">Fast, reliable connection</li>
              </ul>
              
              <a href="tel:+18442172287" className="el-call-button el-orange-btn">
                <span className="el-phone-icon">📞</span> +1-888-348-6689
              </a>
            </div>
          </div>
          
          <div className="el-pricing-card">
            <div className="el-pricing-card-header el-blue">
              <h4 className="el-pricing-card-badge">ULTIMATE FIBER SUPERIOR SPEED</h4>
            </div>
            <div className="el-pricing-card-content">
              <h3 className="el-speed-title">Up to 5 Gigs</h3>
              <p className="el-billing-cycle">Billed annually</p>
              
              <ul className="el-features-list">
                <li className="el-feature-item">One $200 gift card***</li>
                <li className="el-feature-item">The future of the internet</li>
                <li className="el-feature-item">Enjoy top-of-the-line streaming</li>
                <li className="el-feature-item">Built for competitive gaming</li>
              </ul>
              
              <a href="tel:+18442172287" className="el-call-button el-blue-btn">
                <span className="el-phone-icon">📞</span> +1-888-348-6689
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div className="el-container">
        {/* <!-- Hero Section --> */}
        <section className="el-hero-section">
            <div className="el-hero-left">
                <p className="el-tagline">Our Best Deals</p>
                <h1 className="el-hero-title">High-Speed Internet Are Just A Click Away.</h1>
                <p className="el-hero-description">We serve as a premium customer experience outsourcing partner for global startups, scale-ups, and established corporations. Our expertise lies in creating robust solutions</p>
                <p className="el-hero-subtext">For customer engagement and insights, aimed at safeguarding client investments, reducing financial and operational risks, and expediting returns on investment.</p>
            </div>
            <div className="el-hero-right">
                <div className="el-feature-card">
                    <h3 className="el-feature-title">Home Internet</h3>
                    <p className="el-feature-description">Get the speed you need for everything and everyone in your home.</p>
                </div>
                <div className="el-feature-card">
                    <h3 className="el-feature-title">Security & Privacy</h3>
                    <p className="el-feature-description">Protect your data with tools designed to give you peace of mind.</p>
                </div>
                <div className="el-feature-card">
                    <h3 className="el-feature-title">Wireless Internet</h3>
                    <p className="el-feature-description">Tap into the LTE and 5G networks instantly, wherever you have signal.</p>
                </div>
                <div className="el-feature-card">
                    <h3 className="el-feature-title">Rural Internet</h3>
                    <p className="el-feature-description">Connect to the rest of the world, no matter where home is.</p>
                </div>
            </div>
        </section>
        
        {/* <!-- Call To Action Section --> */}
        <section className="el-cta-section">
            <div className="el-cta-image">
                <img src="/api/placeholder/400/320" alt="Woman using laptop" style={{display: "none"}}/>
            </div>
            <div className="el-cta-content">
                <p className="el-award-text">No. 1 Customer Satisfaction Award Winner</p>
                <h2 className="el-cta-title">Make The Right Choice With EarthLink. Call Today.</h2>
                <p className="el-cta-description">EarthLink knows the internet. It's what we were founded on more than 25 years ago. With EarthLink Internet, you can trust us to deliver reliable high speeds and best-in-class customer service.</p>
                <a href="tel:+18442172287" className="el-cta-button">+1-888-348-6689</a>
            </div>
        </section>
        
        {/* <!-- Disclaimer Footer --> */}
        <footer className="el-disclaimer">
            <p>*Actual speeds may vary depending on the distance, line-quality, phone service provider, and number of devices used concurrently. All speeds not available in all areas. Limited-time offer; subject to change.</p>
            <p>**EarthLink was awarded the No. 1 Customer Satisfaction Award in 2020 and 2021 by highspeedinternet.com, in addition to being compared to the publicly measured providers in the 2021 American Customer Satisfaction Index (ACSI) survey of customers rating the reliability of speed and service consistency of their own internet service provider.</p>
            <p>***While supplies last. Void where prohibited and outside the U.S. Offer available to legal U.S. residents (incl. D.C.) who are 18 and older at time of purchase. To be eligible, you must make a Qualifying Purchase, activate the service and remain active for 3 months. Gift: $100 Prepaid Mastercard®. For complete terms and eligibility requirements visit: <Link target="_blank" to="/privacy-policy" className="el-link">Privacy Policy</Link>.</p>
        </footer>
    </div>
    <Footer/>
    </>
  );
};

export default EarthlinkProvider;